import { Component, OnInit } from '@angular/core';
import { isMicrosoftBrowser } from 'appRootPath/utils';

@Component({
  selector: 'app-ie-banner',
  templateUrl: './ie-banner.component.html',
  styleUrls: ['./ie-banner.component.scss']
})
export class IeBannerComponent implements OnInit {
  isIeLessThan10 = false;
  isBannerShown = false;

  constructor() { }

  ngOnInit() {
    if (isMicrosoftBrowser()) {
      this.isIeLessThan10 = true;
      this.isBannerShown = true;
    }
  }
}
